import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { CardBody, Container } from 'reactstrap';
import { Card } from 'reactstrap';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useNavigate } from 'react-router-dom';
import { child_employees, products } from '../../../api/requisition';
import { toast } from 'react-toastify';
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { productCategoryObj } from '../../helper';
import Grid from '@mui/material/Grid';

const RSMAddAllocation = () => {
  const navigate = useNavigate();

  const goToRequisition = () => {

    let hasInvalidData = false;

    // Loop through each row and check for invalid data
    const updatedRows = rows.map(row => {
      const updatedRow = { ...row };
  
      // Check for invalid data in the main row
      if (!row.executiveName) {
        updatedRow.executiveNameError = 'Executive Name is required';
        hasInvalidData = true;
      }
      if (!row.productName) {
        updatedRow.productNameError = 'Product Name is required';
        hasInvalidData = true;
      }
      if (!row.quantity) {
        updatedRow.quantityError = 'Quantity is required';
        hasInvalidData = true;
      }
      // if (!row.value) {
      //   updatedRow.valueError = 'Value is required';
      //   hasInvalidData = true;
      // }
  
      // Check for invalid data in sub-rows
      updatedRow.subRows = row.subRows.map(subRow => {
        const updatedSubRow = { ...subRow };
  
        if (!subRow.productName) {
          updatedSubRow.productNameError = 'Product Name is required';
          hasInvalidData = true;
        }
        if (!subRow.quantity || subRow.quantity === '0') {
          updatedSubRow.quantityError = 'Quantity is required';
          hasInvalidData = true;
        }
        // if (!subRow.value) {
        //   updatedSubRow.valueError = 'Value is required';
        //   hasInvalidData = true;
        // }
  
        return updatedSubRow;
      });
  
      return updatedRow;
    });
  
    setRows(updatedRows);
  
    if (hasInvalidData) {
      return;
    }
    navigate("/rsm/add-requisition", { state: { rows } });
  };

  const [rows, setRows] = useState([
    { executiveName: '', productName: '', quantity: '', value: '', subRows: [], productOptions: [] },
  ]);
  const [executiveOptions, setExecutiveOptions] = useState([]);
  const [productCategory, setProductCategory] = useState('');
  const [productCategoryError, setProductCategoryError] = useState('');

  useEffect(() => {
    getChildEmployees();
    if (productCategory) {
      fetchProductLists(0, '');
    }
  }, [productCategory]);

  const getChildEmployees = async () => {
    try {
      const response = await child_employees();
      if (response.statusCode === 200 && response.data.allChilds.length > 0) {
        const transformedData = response.data.allChilds.map(child => {
          const { id, first_name, last_name } = child.userDetail;
          return { label: `${first_name} ${last_name}`, value: id };
        });
        setExecutiveOptions(transformedData);
      }
    } catch (e) {
      console.log(e);
      toast.error('Error in fetching executives employees for sales head');
    }
  };

  const fetchProductLists = async (rowIndex, search_item) => {
    try {
      const product_list = search_item === ''
        ? await products({ search_type: productCategory })
        : await products({ search_type: productCategory, search_item });

      if (product_list.statusCode === 200 && product_list.data.productList[0].length > 0) {
        const options = product_list.data.productList[0].map(product => ({
          label: product.ItemName,
          value: product.ItemNo,
          dpValue: product.Dp,
          p_type: product.Ptype,
          vertical: product.Vertical,
          itemseg: product.Itemseg,
          category: product.Category,
          mop: product.Mop
        }));

        const updatedRows = [...rows];
        updatedRows[rowIndex] = updatedRows[rowIndex] || {};
        updatedRows[rowIndex].productOptions = options;

        setRows(updatedRows);
        return options;
      }
    } catch (error) {
      console.error('Error fetching product list data:', error);
      toast.error('Error in fetching products');
    }
    return [];
  };

  const handleAddRow = async () => {
    const lastRow = rows[rows.length - 1];
    if (lastRow.executiveName && lastRow.productName && lastRow.quantity && lastRow.value) {
      try {
        const newRowOptions = await fetchProductLists(rows.length, '');
        const newRow = { executiveName: '', productName: '', quantity: '', value: '', subRows: [], productOptions: newRowOptions };
        setRows([...rows, newRow]);
      } catch (error) {
        console.error('Error adding row:', error);
      }
    } else {
      // If the last row is empty, check previous rows for empty fields
      const updatedRows = [...rows];
      rows.forEach((row, index) => {
        if (!row.executiveName) {
          updatedRows[index].executiveNameError = 'Executive Name is required';
        }
        if (!row.productName) {
          updatedRows[index].productNameError = 'Product Name is required';
        }
        if (!row.quantity) {
          updatedRows[index].quantityError = 'Quantity is required';
        }
        // if (!row.value) {
        //   updatedRows[index].valueError = 'Value is required';
        // }
      });
      setRows(updatedRows);
    }
  };
  
  const handleAddSubRow = async (index) => {
    const currentRow = rows[index];
    if (!currentRow.executiveName || !currentRow.productName || !currentRow.quantity || !currentRow.value) {
      //toast.error('Please enter valid information in the main row.');
      //return;
      const newRows = [...rows];
      newRows[index].executiveNameError = !currentRow.executiveName ? 'Executive Name is required' : '';
      newRows[index].productNameError = !currentRow.productName ? 'Product Name is required' : '';
      newRows[index].quantityError = !currentRow.quantity ? 'Quantity is required' : '';
      setRows(newRows);
      return;
    }
    
    // Check if there are any sub-rows and if they have missing information
    const invalidSubRows = currentRow.subRows.filter(subRow => !subRow.productName || !subRow.quantity || !subRow.value);
    if (invalidSubRows.length > 0) {
      // Display error messages for invalid sub-rows
      const newRows = [...rows];
      newRows[index].subRows = newRows[index].subRows.map(subRow => ({
        ...subRow,
        productNameError: !subRow.productName ? 'Product Name is required' : '',
        quantityError: subRow.quantity === '' || subRow.quantity === '0'? 'Quantity is required' : '',
        //valueError:  !subRow.value ? 'Value is required' : ''
      }));
      setRows(newRows);
      return;
    }

    // If all sub-rows are valid, proceed to add a new sub-row
    const newRows = [...rows];
    const newSubRowOptions = await fetchProductLists(index, '');
    newRows[index].subRows.push({ productName: '', quantity: '0', value: '', productOptions: newSubRowOptions });
    setRows(newRows);
  };

  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(newRows);
  };

  const handleDeleteSubRow = (rowIndex, subIndex) => {
    const newRows = [...rows];
    newRows[rowIndex].subRows = newRows[rowIndex].subRows.filter((_, i) => i !== subIndex);
    setRows(newRows);
  };

  const handleInputChange = async (index, field, value) => {
    const updatedRows = [...rows];
    const oldValue = updatedRows[index][field]; // Store the old value
    updatedRows[index][field] = value;
    setRows(updatedRows);

    // Check if the input value has changed
    if (oldValue === value) {
      return;
    }

    if (field === 'quantity' && value !== '') {
      const selectedProduct = updatedRows[index]['productName'];
      if (selectedProduct) {
        const calculatedValue = parseInt(value, 10) * parseInt(selectedProduct.dpValue, 10);
        updatedRows[index]['value'] = isNaN(calculatedValue) || calculatedValue ===0  ? '' : calculatedValue.toString();
        setRows(updatedRows);
      }
    }
    if (field === 'executiveName') {
        if (value && !productCategory) {
          setProductCategoryError('Type is required');
        } else {
          setProductCategoryError('');
        }
      }
   
    // Clear error message when valid data is entered
    const newRows = [...rows];
    newRows[index].executiveNameError = '';
    newRows[index].productNameError = '';
    newRows[index].quantityError = '';
    //newRows[index].valueError = '';
    setRows(newRows);

    // Check for missing information in main row
    // if (!newRows[index].executiveName || !newRows[index].productName || !newRows[index].quantity || !newRows[index].value) {
    //   newRows[index].executiveNameError = !newRows[index].executiveName ? 'Executive Name is required' : '';
    //   newRows[index].productNameError = !newRows[index].productName ? 'Product Name is required' : '';
    //   newRows[index].quantityError = !newRows[index].quantity ? 'Quantity is required' : '';
    //   newRows[index].valueError = !newRows[index].value ? 'Value is required' : '';
    //   setRows(newRows);
    // }
  };

  const handleSubInputChange = async (rowIndex, subIndex, field, value) => {
    const newRows = [...rows];
    newRows[rowIndex].subRows[subIndex][field] = value;
    setRows(newRows);

    if (field === 'productName' && value !== '') {
      const options = await fetchProductLists(rowIndex, value.label || value);
      newRows[rowIndex].subRows[subIndex].productOptions = options;
      setRows(newRows);
    }

    if (field === 'quantity' && value !== '') {
      const selectedProduct = newRows[rowIndex].subRows[subIndex]['productName'];
      if (selectedProduct) {
        const calculatedValue = parseInt(value, 10) * parseInt(selectedProduct.dpValue, 10);
        newRows[rowIndex].subRows[subIndex]['value'] = isNaN(calculatedValue) || calculatedValue ===0 ? '' : calculatedValue.toString();
        setRows(newRows);
      }
    }

    // Clear error message when valid data is entered
    newRows[rowIndex].subRows[subIndex].productNameError = '';
    newRows[rowIndex].subRows[subIndex].quantityError = '';
   // newRows[rowIndex].subRows[subIndex].valueError = '';
    setRows(newRows);
  };

  const handleProductCategoryChange = (event, newValue) => {
    if (newValue) {
      setProductCategory(newValue.value);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="Create Requisition" pageTitle="Requisitions" /> */}
          <div className='mb-3' style={{ fontSize: '20px', textAlign: 'center' }}>
          <h3 className="requisition_text mb-0">Requisition Form</h3>
          </div>
          <Card>
            <CardBody>
              <div className='d-flex align-items-center mb-2'>
                <div> <p className='mb-0 me-2 requisition_type_text'>Select Requisition Type : </p></div>
                <div>
                  <Autocomplete
                    className="create_requisition_field"
                    id={`product-category`}
                    sx={{ width: 150 }}
                    options={productCategoryObj}
                    value={productCategoryObj.find(option => option.value === productCategory)}
                    onChange={handleProductCategoryChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Type"
                      />
                    )}
                  />
                    {!productCategory && productCategoryError && <span className="error-message" style={{ color: 'red', fontSize: '14px' }}>{productCategoryError}</span>}

                </div>
              </div>
              {rows.map((row, index) => (
                <div
                  className='create_requisition'
                  key={index}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    marginBottom: '16px',
                    marginTop: '15px',
                    padding: '10px',
                    backgroundColor: '#FAFDFF',
                    border: '1px solid #C3E8FF',
                    borderRadius: '5px',
                  }}
                >
                   <Grid container item xs={12} spacing={1}>
                   <Grid item xs={3}>
                      <Autocomplete
                        disablePortal
                        className="create_requisition_field"
                        id={`executive-name-${index}`}
                        options={executiveOptions}
                        // sx={{ width: 200 }}
                        value={row.executiveName}
                        onChange={(event, newValue) => handleInputChange(index, 'executiveName', newValue)}
                        renderInput={(params) => <TextField {...params} label="RSM Name" />}
                      />
                      {row.executiveNameError && <span className="error-message" style={{ color: 'red' }}>{row.executiveNameError}</span>}
                    </Grid>
                    <Grid item xs={3}>
                      <Autocomplete
                        // sx={{ width: 200 }}
                        className="create_requisition_field"
                        disablePortal
                        id={`product-name-${index}`}
                        options={row.productOptions}
                        value={row.productName}
                        onChange={(event, newValue) => handleInputChange(index, 'productName', newValue)}
                        onInputChange={(event, newInputValue) => {
                          if (newInputValue !== row.productName) {
                            fetchProductLists(index, newInputValue);
                          }
                        }}
                        renderInput={(params) => <TextField {...params} label="Product Name" />}
                      />
                      {row.productNameError && <span className="error-message" style={{ color: 'red' }}>{row.productNameError}</span>}
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        className="create_requisition_textfield"
                        id={`quantity-${index}`}
                        label="Quantity"
                        variant="outlined"
                        value={row.quantity}
                        onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                        // sx={{ width: '100%' }}
                      />
                      {row.quantityError && <span className="error-message" style={{ color: 'red' }}>{row.quantityError}</span>}
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        className="create_requisition_textfield"
                        id={`value-${index}`}
                        label="Value"
                        variant="outlined"
                        value={row.value}
                        onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                        // sx={{ width: '100%' }}
                      />
                      {row.valueError && <span className="error-message" style={{ color: 'red' }}>{row.valueError}</span>}
                    </Grid>
                    {index >= 0 && rows.length > 1 && (
                      <Grid item xs={1} className='d-flex align-items-center mb-1 ms-1'>
                        <HighlightOffIcon onClick={() => handleDeleteRow(index)} color='error' />
                      </Grid>
                    )}
                  </Grid>
                  {row.subRows.map((subRow, subIndex) => (
                    <Grid container item xs={12} spacing={1} 
                      key={subIndex}
                      style={{
                        // display: 'flex',
                        // gap: '10px',
                        // marginBottom: '5px',
                        // padding: '10px',
                        // backgroundColor: '#F0F8FF',
                        // border: '1px solid #B0E0E6',
                        // borderRadius: '5px',
                        marginLeft: '24.5%',
                        marginTop: '4px' // Adjust according to the width of main row elements and gap
                      }}
                    >
                      <Grid item xs={3}>
                        <Autocomplete
                          // sx={{ width: 200 }}
                          className="create_requisition_field"
                          disablePortal
                          id={`sub-product-name-${index}-${subIndex}`}
                          options={subRow.productOptions}
                          value={subRow.productName}
                          onInputChange={(event, newValue) => handleSubInputChange(index, subIndex, 'productName', newValue)}
                          onChange={(event, newValue) => handleSubInputChange(index, subIndex, 'productName', newValue)}
                          renderInput={(params) => <TextField {...params} label="Product Name" />}
                        />
                        {subRow.productNameError && <span className="error-message" style={{ color: 'red' }}>{subRow.productNameError}</span>}
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          className="create_requisition_textfield"
                          id={`sub-quantity-${index}-${subIndex}`}
                          label="Quantity"
                          variant="outlined"
                          value={subRow.quantity}
                          onChange={(event) => handleSubInputChange(index, subIndex, 'quantity', event.target.value)}
                          // sx={{ width: '100%' }}
                        />
                        {subRow.quantityError && <span className="error-message" style={{ color: 'red' }}>{subRow.quantityError}</span>}
                      </Grid>
                      <Grid item xs={2}>
                        <TextField
                          className="create_requisition_textfield"
                          id={`sub-value-${index}-${subIndex}`}
                          label="Value"
                          variant="outlined"
                          value={subRow.value}
                          onChange={(event) => handleSubInputChange(index, subIndex, 'value', event.target.value)}
                          // sx={{ width: '100%' }}
                        />
                        {subRow.valueError && <span className="error-message" style={{ color: 'red' }}>{subRow.valueError}</span>}
                      </Grid>
                      <Grid item xs={2} className='d-flex align-items-center mb-1 ms-1'>
                        <HighlightOffIcon onClick={() => handleDeleteSubRow(index, subIndex)} color='error' />
                      </Grid>
                    </Grid>
                  ))}
                  <button className='add_more_button' onClick={() => handleAddSubRow(index)} style={{ width: '120px',marginLeft: '25%', }}>+ Add Product</button>
                </div>
              ))}
              <button className='add_more_button' onClick={handleAddRow}>+ Add More</button>
            </CardBody>
            <Container fluid>
              <div className='mb-2' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '16px', marginRight: '8px', marginBottom: '3px', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
                <Button className="save_button" variant="contained" onClick={() => goToRequisition()}>Save</Button>
              </div>
            </Container>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default RSMAddAllocation;
